import debugFactory from "debug";

export default function( namespace, target, { skipFirstArg = false, } ) {
	const debug = debugFactory( namespace );
	Object.keys( target ).forEach( key => {
		if ( typeof target[ key ] === "function" ) {
			const handler = target[ key ];
			target[ key ] = ( ...args ) => {
				const loggedArgs = skipFirstArg ? args.slice( 1 ) : args;
				debug( key, ...loggedArgs );
				return handler( ...args );
			};
		}
	} );
	return target;
}



// WEBPACK FOOTER //
// ./src/helpers/debugWrapper.js